import { Link } from 'react-router-dom';

import Button from '@modules/common/components/button';

const EmptyCartMessage = () => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-10 pt-[200px] sm:pt-[300px]"
      data-testid="empty-cart-message"
    >
      <p className="text-grey-50">您的購物車尚未有商品</p>
      <div>
        <Link to="/">
          <Button variant="primary" className="min-w-[80vw] sm:min-w-[400px]">
            馬上去逛逛
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default EmptyCartMessage;
